import React, { useMemo, useState } from "react";
import { PageHero, PageBody, Lightbox } from "./_shared";
import { usePoly } from "./PolyLayout";

export default function Gallery() {
  const data = usePoly();
  const photos = data.gallery || [];
  const [idx, setIdx] = useState(-1);

  const types = useMemo(() => {
    const set = new Set();
    photos.forEach((p) => p.gallery_type && set.add(p.gallery_type));
    return Array.from(set);
  }, [photos]);
  const [filter, setFilter] = useState("");
  const visible = filter ? photos.filter((p) => p.gallery_type === filter) : photos;

  return (
    <div data-testid="poly-gallery">
      <PageHero eyebrow="Moments" title="Gallery" accent="pink" />
      <PageBody>
        {types.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-6">
            <button
              type="button"
              onClick={() => setFilter("")}
              className={`text-sm px-4 py-2 rounded-full transition-colors ${
                filter === ""
                  ? "bg-blue-700 text-white font-semibold"
                  : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50"
              }`}
            >
              All
            </button>
            {types.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setFilter(t)}
                className={`text-sm px-4 py-2 rounded-full transition-colors ${
                  filter === t
                    ? "bg-blue-700 text-white font-semibold"
                    : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        )}

        {visible.length === 0 ? (
          <div className="text-center bg-white rounded-xl shadow p-12 text-slate-500">
            Photos will appear here once the institute uploads them.
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {visible.map((p, i) => (
              <button
                key={p.id}
                type="button"
                onClick={() => setIdx(i)}
                data-testid={`poly-gallery-photo-${p.id}`}
                className="aspect-square overflow-hidden rounded-lg shadow-sm hover:shadow-lg transition-shadow bg-slate-100"
              >
                <img
                  src={p.image_url}
                  alt={p.caption || ""}
                  className="w-full h-full object-cover hover:scale-110 transition-transform"
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        )}
      </PageBody>
      {idx >= 0 && (
        <Lightbox photos={visible} idx={idx} onIdx={setIdx} onClose={() => setIdx(-1)} />
      )}
    </div>
  );
}
